import React, { useState, useEffect } from 'react';
import { Box, TextField, MenuItem, Grid, IconButton, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';


import { useSettings } from '../../../hook/useSettings';

export function InfoApp({ dataSettings }) {
    const countries = [
        
        { name: 'Perú', code: 'CA', flag: 'pe', currency: 'S/' },
        { name: 'Ecuador', code: 'EC', flag: 'ec', currency: 'USD' },
        { name: 'Colombia', code: 'CO', flag: 'co', currency: '$' },
        { name: 'Bolivia', code: 'MX', flag: 'bo', currency: '$b' },
        { name: 'Mexico', code: 'MX', flag: 'mx', currency: '$' },
    ]


  const { editSetting } = useSettings();

  const getInitialValue = (settings, name) => {
    const setting = settings.find(s => s.name === name);
    return setting ? setting.value : '';
  };

  const getSettingId = (settings, name) => {
    const setting = settings.find(s => s.name === name);
    return setting ? setting.id : null;
  };

  const [nameStore, setNameStore] = useState(getInitialValue(dataSettings, 'name'));
  const [phone, setPhone] = useState(getInitialValue(dataSettings, 'phone'));
  const [email, setEmail] = useState(getInitialValue(dataSettings, 'email'));
  const [address, setAddress] = useState(getInitialValue(dataSettings, 'address'));
  const [country, setCountry] = useState(getInitialValue(dataSettings, 'country'));
  const [currency, setCurrency] = useState('');
  const [storeHours, setStoreHours] = useState(getInitialValue(dataSettings, 'store_hours') || [

    { day: 'Monday', open: '', close: '' },
    { day: 'Tuesday', open: '', close: '' },
    { day: 'Wednesday', open: '', close: '' },
    { day: 'Thursday', open: '', close: '' },
    { day: 'Friday', open: '', close: '' },
    { day: 'Saturday', open: '', close: '' },
    { day: 'Sunday', open: '', close: '' }

  ]);

  const [editableFields, setEditableFields] = useState({
    nameStore: false,
    phone: false,
    email: false,
    address: false,
    country: false,
    storeHours: storeHours.map(() => false),
  });

  useEffect(() => {
    const selectedCountry = countries.find(c => c.code === country);
    if (selectedCountry) {
      setCurrency(selectedCountry.currency);
    }
  }, [country]);

  const handleStoreHoursChange = (index, field, value) => {
    const updatedStoreHours = [...storeHours];
    updatedStoreHours[index][field] = value;
    setStoreHours(updatedStoreHours);
  };

  const saveSettingField = async (fieldName, value) => {
    const setting = dataSettings.find(s => s.name === fieldName);
    if (setting) {
      try {
        await editSetting(setting.id, { value });
      } catch (error) {
        console.error('Error saving setting:', error);
      }
    }
  };
  
  const toggleEditField = async (field, value) => {
    if (editableFields[field]) {
      await saveSettingField(field, value);
    }
    setEditableFields({ ...editableFields, [field]: !editableFields[field] });
  };
  
  const toggleEditStoreHour = async (index, field, value) => {
    if (editableFields.storeHours[index]) {
      const updatedStoreHours = [...storeHours];
      updatedStoreHours[index][field] = value;
      await saveSettingField('store_hours', JSON.stringify(updatedStoreHours));
      setStoreHours(updatedStoreHours);
    }
    const updatedEditableStoreHours = [...editableFields.storeHours];
    updatedEditableStoreHours[index] = !updatedEditableStoreHours[index];
    setEditableFields({ ...editableFields, storeHours: updatedEditableStoreHours });
  };
  

  const saveSettings = async () => {
    try {
      const settingsToUpdate = [
        { id: getSettingId(dataSettings, 'name'), name: 'name', value: nameStore },
        { id: getSettingId(dataSettings, 'phone'), name: 'phone', value: phone },
        { id: getSettingId(dataSettings, 'email'), name: 'email', value: email },
        { id: getSettingId(dataSettings, 'address'), name: 'address', value: address },
        { id: getSettingId(dataSettings, 'country'), name: 'country', value: country },
        { id: getSettingId(dataSettings, 'store_hours'), name: 'store_hours', value: storeHours },
      ];

      for (const setting of settingsToUpdate) {
        if (setting.id) {
          await editSetting(setting.id, { value: setting.value });
        }
      }

      alert('Settings saved successfully!');
    } catch (error) {
      console.error('Error saving settings:', error);
      alert('Failed to save settings.');
    }
  };

  return (
    <>
      <Box
        component="form"
        sx={{
          '& > * >:not(style)': { m: 1, width: '100%' },
        }}
        noValidate
        autoComplete="off"
        className='row-cl'
      >
        <div className="cl-60">
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <TextField
                fullWidth
                name="name"
                label="Nombre del Negocio"
                variant="outlined"
                value={nameStore}
                onChange={(e) => setNameStore(e.target.value)}
                disabled={!editableFields.nameStore}
              />
            </Grid>
            <Grid item xs={2}>
            <IconButton onClick={() => toggleEditField('nameStore', nameStore)}>
                {editableFields.nameStore ? <SaveIcon /> : <EditIcon />}
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <TextField
                fullWidth
                name="email"
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={!editableFields.email}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={() => toggleEditField('email')}>
                {editableFields.email ? <SaveIcon /> : <EditIcon />}
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <TextField
                fullWidth
                select
                name="country"
                label="País"
                variant="outlined"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                disabled={!editableFields.country}
              >
                {countries.map((country) => (
                  <MenuItem key={country.code} value={country.code}>
                    <img className="flag" src={`/${country.flag}.png`}/> {country.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={() => toggleEditField('country')}>
                {editableFields.country ? <SaveIcon /> : <EditIcon />}
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <TextField
                fullWidth
                name="currency"
                label="Moneda"
                variant="outlined"
                value={currency}
                helperText="Si deseas cambiar el tipo de moneda contacta con servcio al cliente."
                disabled
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <TextField
                fullWidth
                name="phone"
                label="Teléfono"
                variant="outlined"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={!editableFields.phone}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={() => toggleEditField('phone')}>
                {editableFields.phone ? <SaveIcon /> : <EditIcon />}
              </IconButton>
            </Grid>
          </Grid>

       <Grid item xs={5}>
        <Button variant="contained" color="primary" onClick={saveSettings}>
          Guardar Configuración
        </Button>
        </Grid>
        </div>
        
      </Box>
    </>
  );
}

